import Error from "next/error";
export default function Home() {
  return <Error statusCode={404} />;
}
